import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import {
  IGetServiceProps,
  IGlobalMetaSchema,
} from "@api/types/globalService.types";
import { IStateResponseSchema } from "@api/types/masterResponse.types";

interface IGetAllStateResponseService {
  data: IStateResponseSchema[];
  meta: IGlobalMetaSchema;
}

export const useGetAllStateService = ({
  page = "1",
  per_page = "15",
  enableQuery,
  showActiveOnly = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allStateService = useQuery({
    queryKey: [
      ...CACHE_KEYS.STATE,
      page,
      per_page,
      debouncedQuery,
      showActiveOnly,
    ],
    queryFn: (): Promise<IGetAllStateResponseService> =>
      handleGlobalGetRequestQuery({
        url: URLS.STATES,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          include: "cities_count,country",
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchQuery, setSearchQuery },
    services: { allStateService },
  };
};

export const useGetSingleStateService = ({
  state_id,
}: {
  state_id: number;
}) => {
  const singleStateService = useQuery({
    queryKey: [...CACHE_KEYS.STATE, state_id],
    queryFn: (): Promise<IGetAllStateResponseService> =>
      handleGlobalGetRequestQuery({
        url: `${URLS.STATES}/${state_id}`,
      }),
    enabled: state_id ? true : false,
  });

  return {
    service: { singleStateService },
  };
};
